import { Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useMySubscriptionStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    sidePanel: {
      width: '148px',
      backgroundColor: theme.customPalette.lightGrey,
      padding: '20px',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        justifyContent: 'center',
        width: 'calc(100% - 40px)',
      },
    },
    sidePanelHeader: {
      fontWeight: theme.fontWeight,
      textTransform: 'uppercase',
      marginBottom: theme.spacing(),
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    sidePanelValueHeader: {
      fontWeight: theme.fontWeight,
    },
    sidePanelValue: {
      wordBreak: 'break-word',
      fontWeight: theme.fontWeight,
    },
    sidePanelValuePair: {
      [theme.breakpoints.up('sm')]: {
        paddingBottom: `${Number(theme.spacing().replace('px', '')) * 2}px`,
      },
      [theme.breakpoints.down('sm')]: {
        paddingRight: `${Number(theme.spacing().replace('px', '')) * 2}px`,
      },
    },
    sidePanelValueIsNegative: {
      color: theme.customPalette.red,
    },
    tableContainer: {
      [theme.breakpoints.up('sm')]: {
        width: '100%',
        paddingLeft: '42.5px',
      },
      [theme.breakpoints.down('sm')]: {
        paddingTop: '20px',
      },
    },
    firstColumnContent: {
      display: 'flex',
      textTransform: 'capitalize',
      '& > :first-child': {
        paddingRight: '10px',
      },
    },
  })
);
